<div class="action-buttons-container" [class.full-width]="isFullWidth" *ngIf="!showMessageTemplate">
	<ng-container *ngTemplateOutlet="buttonsTemplate || null"></ng-container>
</div>

<div class="actions-scroll" *ngIf="!showMessageTemplate && buttons && buttons.length > (visibleItemsCount + 1)">
	<action-button (click)="showNextPage()" @slideUp @fadeIn [icon]="ButtonIcons.Next" [name]="'Next'">
	</action-button>
</div>

<ng-container *ngIf="showMessageTemplate">
	<ng-container *ngTemplateOutlet="messagesTemplate || null"></ng-container>
</ng-container>